module.exports = VueLazyload;